module.exports = __webpack_public_path__ + "media/customizations/regencyattentrails/logo-3b4c23b57723343534664e3bc3e7ac0e.png";